import Main from "./components/Main";
import Signup from "./components/auth/Signup";
import { Route, Routes } from "react-router-dom";
import Login from "./components/auth/Login";
import EmailSent from "./components/auth/EmailSent";
import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
        <Route path="/" element={<Main />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/email-sent" element={<EmailSent />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
